<ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button></ion-menu-button>
      </ion-buttons>
      <ion-title>Taal Composer</ion-title>
    </ion-toolbar>
  </ion-header>
  
  <ion-content class="ion-padding">
    <ion-button expand="block" color="primary" *ngIf="editTaalIndex === null" (click)="addTaal()">
        New Taal
      </ion-button>
      <ion-list *ngIf="taalDisplay">
    <ion-item>
      <ion-input  ngDefaultControl name="name" [(ngModel)]="newTaal.name" placeholder="Taal Name"></ion-input>
    </ion-item>
  
    <ion-item>
      <ion-input    ngDefaultControl name="beats" type="number" [(ngModel)]="newTaal.numberOfBeats" placeholder="Total Beats"></ion-input>
    </ion-item>
  
    <ion-item>
      <ion-select  ngDefaultControl name="tempogenre" [(ngModel)]="newTaal.tempoGenre" placeholder="Tempo">
        <ion-select-option *ngFor="let t of (TempoGenre | keyvalue)" [value]="t.value">{{ t.value }}</ion-select-option>
      </ion-select>
    </ion-item>
    <ion-item-divider></ion-item-divider>
        <!-- Inputs for New Vibhag -->
<ion-item>
    <ion-input
      [(ngModel)]="vibhagLabel"
      placeholder="Vibhag Label"
   
      ngDefaultControl>
    </ion-input>
  </ion-item>
  
  <ion-item>
    <ion-input label="Start Beat"
      type="number"
      [(ngModel)]="vibhagStartBeat"
      placeholder="Vibhag Start Beat"
      ngDefaultControl>
    </ion-input>
  </ion-item>
  
  <ion-item>
    <ion-input
      label="Duration"
      type="number"
      (ionChange)='beatsChanged($event)'
      [(ngModel)]="vibhagDuration"
      placeholder="Vibhag Duration"
      ngDefaultControl>
    </ion-input>
  </ion-item>
  
    <ion-title>Markers by Beat</ion-title>
    <ion-toolbar *ngIf="vibhagDuration>0">
    <ion-buttons slot="end">

  <ion-button  fill='solid' (click)='popupMarker(ix)' color="dark" *ngFor=" let marker of markers ;let ix=index" >
   {{ix+vibhagStartBeat}} :{{marker?marker:'None'}}
  </ion-button>
  </ion-buttons>
  </ion-toolbar>

  <ion-button expand="block" color="primary" *ngIf="editIndex === null" (click)="addVibhag()">
  Add Vibhag
</ion-button>

<ion-button expand="block" color="warning" *ngIf="editIndex !== null" (click)="updateVibhag()">
  Update Vibhag
</ion-button>
<ion-list *ngIf="newTaal.vibhags.length > 0">
    <ion-item *ngFor="let v of newTaal.vibhags; let i = index">
      <ion-label>
        {{v.label}} - Beats: {{v.durationInBeats}} (Start: {{v.startBeat}})
      </ion-label>
      <ion-button size="small" slot="end" (click)="loadVibhagForEdit(i)">Edit</ion-button>
    </ion-item>
  </ion-list>
 

    <ion-button expand="block" color="success" (click)="saveTaal()">Save Taal</ion-button>
  <ion-button  expand="block" color="dark" (click)="taalDisplay=false">Close</ion-button>
</ion-list>  
  <ion-item>
      <ion-input  ngDefaultControl [(ngModel)]="searchTerm" placeholder="Search Taals..."></ion-input>
    </ion-item>
  
    <ion-list>
      <ion-item *ngFor="let taal of filteredTaals; let i = index">
        <ion-label>
          <h2>{{taal.name}} ({{taal.numberOfBeats}} beats)</h2>
          <p>{{taal.tempoGenre}}</p>
        </ion-label>
        <ion-button slot="end" color="success" (click)="updateTaal(i)">Edit</ion-button>
     
        <ion-button slot="end" color="danger" (click)="deleteTaal(i)">Delete</ion-button>
      </ion-item>
    </ion-list>
    <ion-radio-group (ionChange)="setLan($event)">
        <ion-radio value="hi">Hindi</ion-radio>
   
        <ion-radio value="en">English</ion-radio>
    </ion-radio-group>
  <ion-button (click)="parseTest()">Parse</ion-button>
  
  <swiper-container class='swiper-container' *ngIf="hasmeasures() ">
    <swiper-slide  *ngFor="let measure of omanad() let mx=index">

        <div class='measure-container'  [ngStyle]="{'grid-template-columns':measure_class}"
        >
        <div  class='vibhag-header vibhag-4' [ngStyle]="{'grid-row':1,'grid-column': (1+ix) }" *ngFor="let vibhag of measure.vibhag;let ix=index">
        Vibhag {{ix+1}};     
        </div>
            <div  class='vibhag-container' [ngStyle]="{'grid-row':2,'grid-column': (1+ix) }"*ngFor="let vibhag of measure.vibhag;let ix=index">
                <div  class="beat-header-container" *ngFor="let beat of vibhag.beats; let jx=index">
                # {{jx+1}}  
                </div>
               <div  class="beat-container" *ngFor="let beat of vibhag.beats; let jx=index">
                @let beatdata=cparser?.beatToOmad(beat,language);<div class=" tiny-font">
<span  [innerHTML]='omenaadbeatsubdata(beatdata)' [class]="language=='en'?'bhatkhande-english':'bhatkhande-hindi'">
       {{omenaadbeatsubdata(beatdata)}}</span>
                   </div>
                
                </div>
            </div>
     </div>
    </swiper-slide>
    <div class="swiper-button-prev"></div>
  <div class="swiper-button-next"></div>
  </swiper-container>
  <div class="swiper-button-prev"></div>
  <div class="swiper-button-next"></div>
</ion-content>
  
